import { FunctionComponent } from "react"
import { GetServerSideProps } from "next"
import Head from "next/head"

import getSettings from "@/services/settings"
import getCars from "@/services/cars"
import { Settings } from "@/types/settings"
import { ICars } from "@/types/contentful"
import Section from "@/components/Section/Section"
import FormStep from "@/components/FormSteps/FormSteps"
import LocationStep from "@/components/forms/LocationStep/LocationStep"

import styles from "./styles.module.scss"

type OrderDetailsPageProps = {
  settings: Settings
  car: ICars
}

export const getServerSideProps: GetServerSideProps<
  OrderDetailsPageProps
> = async ({ query, res }) => {
  if (!query.slug) {
    res.writeHead(301, { location: "/cars" })
    res.end()
  }

  const settingsPromise = getSettings()
  const carsPromise = getCars({
    slug: query.slug as string,
    include: 1,
  }) as Promise<ICars>

  const [settings, car] = await Promise.all([settingsPromise, carsPromise])

  if (!car) {
    res.writeHead(301, { location: "/cars" })
    res.end()
  }
  car.fields.sections = []

  return {
    props: { settings, car },
  }
}

const Order: FunctionComponent<OrderDetailsPageProps> = ({ car }) => {
  return (
    <>
      <Head>
        <meta name="robot" content="noindex, nofollow" />
      </Head>
      <Section sectionClassName={styles.section}>
        <FormStep currentStep={2} />
        <LocationStep car={car.fields} />
      </Section>
    </>
  )
}

export default Order
